import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ReleaseMode } from 'shell/models/release-mode';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

interface ReleaseModeProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
}

const ReleaseModeListComponent = ({
  disabled,
  onChange,
  value,
  error,
}: ReleaseModeProps): React.ReactElement => {
  const [releaseModes] = useHttpFetch<HttpResponseList<ReleaseMode>, Array<ItemVM>>(
    `${__CERTIFICATION_API_URL__}/certificazione/modalita-rilascio`,
    {
      onBootstrap: true,
      initialData: [],
      options: {
        method: 'GET',
        abortable: true,
        errorCatching: false,
        loading: false,
      },
      transformer: (response) => {
        return response.data.payload.list.map((item) => ({
          id: item.key?.codiceModalitaRilascio || '',
          value: item.descrizione || '',
        }));
      },
    }
  );

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="release-mode-label">
        Modalità di rilascio
      </InputLabel>
      <PmiSelect
        labelId="release-mode-label"
        id="release-mode"
        name="release-mode"
        value={value}
        label="Modalità di rilascio"
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {(releaseModes.data as Array<ItemVM>).map((mode: ItemVM) => (
          <MenuItem key={mode.id} value={mode.id}>
            {mode.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ReleaseModeListComponent.displayName = 'List release modes component';

const ReleaseModeList = memo(ReleaseModeListComponent);

export default ReleaseModeList as typeof ReleaseModeListComponent;
